// OCR pipeline card. Renders the model-extracted text and any
// detected place name. The place name is the high-value field — if
// a road sign reads "STOCKHOLM 12 KM" we know the location with
// near-certainty, regardless of what the pinpoint ensemble guessed.

import { PipelineCard } from "./PipelineCard";
import type { CardState } from "../state/store";

export function OcrPipelineCard({ state }: { state: CardState }) {
  return (
    <PipelineCard pipeline="ocr" state={state}>
      {state.status === "complete" && state.ocr ? (
        <div className="flex flex-col gap-1">
          {state.ocr.place_name ? (
            <div className="flex items-center gap-2">
              <span className="font-semibold">{state.ocr.place_name}</span>
              {state.ocr.country && (
                <span className="text-fg-muted text-[10px]">
                  ({state.ocr.country})
                </span>
              )}
              <span className="ml-auto text-[10px] tabular-nums">
                conf {(state.ocr.confidence * 100).toFixed(0)}%
              </span>
            </div>
          ) : (
            <div className="text-fg-muted text-[11px]">No place name detected</div>
          )}
          {state.ocr.extracted.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {state.ocr.extracted.slice(0, 8).map((item, i) => (
                <span
                  key={i}
                  className="rounded bg-white/5 px-1.5 py-0.5 text-[10px] text-fg-muted"
                  title={item.kind}
                >
                  {item.text}
                </span>
              ))}
              {state.ocr.extracted.length > 8 && (
                <span className="text-[10px] text-fg-muted">
                  +{state.ocr.extracted.length - 8} more
                </span>
              )}
            </div>
          )}
        </div>
      ) : null}
    </PipelineCard>
  );
}
